export default   {
  strToBinary: function (str){
    let result = [];
    let list = str.split("");
    for(let i=0;i<list.length;i++){
      if(i != 0){
        result.push(" ");
      }
      let item = list[i];
      let binaryStr = item.charCodeAt().toString(2);
      result.push(binaryStr);
    }
    return result.join("");
  },
//将二进制字符串转换成Unicode字符串
  binaryToStr :function(str){
    let result = [];
    let list = str.split(" ");
    for(let i=0;i<list.length;i++){
      let item = list[i];
      let asciiCode = parseInt(item,2);
      let charValue = String.fromCharCode(asciiCode);
      result.push(charValue);
    }
    return result.join("");
  },
  byte2Hex: function (byte) {
    return byte.toString(16).length === 1? "0"+byte.toString(16) :byte.toString(16);
  },
  bytes2Hex: function (bytes) {
    let hex = ""
    for (let i = 0; i < bytes.length; i++) {
      hex += this.byte2Hex(bytes[i]);
    }
    return hex.toUpperCase();
  },

  hex2Bytes(hex) {
    let bytes = [];
    for (let i = 0; i <hex.length ; i+=2) {
      bytes.push(parseInt(hex.slice(i,i+2),16))
    }
    return bytes;
  }

}





